import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { MESSAGE_TYPE } from 'src/constants/message.constant';
import { environment } from 'src/environments/environment';
import { EmegencyDialogComponent } from '../molecules/emegency-dialog/emegency-dialog.component';
import { SignalRMessage } from '../shared/models/event.model';
import { ToastService } from './toast.service';

export interface MirrorEvent {
  type: "navigate" | "input" | "click" | "map-move" | "map-zoom" | "marker-click" 
        | "marker-close" | "date-change" | "emergency-focus" | "request-mirror" | "un-request-mirror" | "broadcast" 
        | "broadcast-close" | "click-pin" | "close-pin" | "refresh" | "emergency-close";
  payload: any;
}

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: signalR.HubConnection | undefined;
  public connectionId: string | undefined;

  private seekerMessagesSubject = new BehaviorSubject<SignalRMessage[]>([]);
  private knightMessageSubject = new BehaviorSubject<SignalRMessage[]>([]);
  private notificationMessageSubject = new BehaviorSubject<SignalRMessage[]>(
    []
  );
  private gpsRealtimeMessageSubject = new BehaviorSubject<SignalRMessage[]>([]);
  private emergencyMessageSubject = new BehaviorSubject<SignalRMessage[]>([]);
  private gpsRealtimeOutsideMessageSubject = new BehaviorSubject<SignalRMessage[]>([]);

  public seekerMessages$ = this.seekerMessagesSubject.asObservable();
  public knightMessages$ = this.knightMessageSubject.asObservable();
  public notificationMessages$ = this.notificationMessageSubject.asObservable();
  public gpsRealtimeMessages$ = this.gpsRealtimeMessageSubject.asObservable();
  public gpsRealtimeOutsideMessage$ = this.gpsRealtimeOutsideMessageSubject.asObservable();
  public emergencyMessages$ = this.emergencyMessageSubject.asObservable();
  isStartedListener = false;


  private mirorMessagesSubject = new BehaviorSubject<MirrorEvent[]>([]);
  public mirrorMessages$ = this.mirorMessagesSubject.asObservable();

  private bulkCreateProgressSubject = new BehaviorSubject<any>(null);
  public bulkCreateProgress$ = this.bulkCreateProgressSubject.asObservable();

  public mirrorUsers : string[] = [];

  constructor(private modalController: ModalController) {}

  async startConnection(token: string) {
    // console.log('here');
    // console.log(this.authService.currentUserValue.access_token);
    // const currentUser = await this.authService.getCurrentUserValue();
    if (this.hubConnection?.state !== signalR.HubConnectionState.Disconnected) {
      await this.hubConnection?.stop();
    }

    if (token) {
      const baseApi = environment.apiEndpoint.replace(/\/api$/, ""); ///environment.apiEndpoint.replace('/api', '');
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseApi}/urknighthub`, {
          accessTokenFactory: () => token,
          //withCredentials: true, // Important for CORS
        })
        .withAutomaticReconnect()
        .build();

      await this.hubConnection.start();

      console.log('Connection started');
      //.toPromise()
      //  .catch(err => console.log('Error while starting connection: ' + err));

      console.log(this.hubConnection.connectionId);
      if (this.hubConnection.connectionId != null)
        this.connectionId = this.hubConnection.connectionId!;
    }
  }

  async reconnectWithNewToken() {
    if (this.hubConnection?.state !== signalR.HubConnectionState.Disconnected) {
      await this.hubConnection?.stop();
    }
    await this.hubConnection?.start();
  }

  async stopConnection() {
    console.log('Connection stopped');
    this.connectionId = '';
    await this.hubConnection?.stop();
  }

  addListener() {
    // console.log(this.connectionId, this.isStartedListener);
    // // if(!this.connectionId)
    // //   return;

    // if(this.isStartedListener)
    //   return;
    this.hubConnection?.off('ReceiveChange');
    this.hubConnection?.off('ReceiveMessage');
    this.hubConnection?.off('ForceDisconnect');

    this.hubConnection?.on('ReceiveChange', (data) => {
      // console.log('Received data: ', data);
      // Handle the data
    });

    this.hubConnection?.on('ReceiveMessage', (data: SignalRMessage) => {
      // console.log('Received data: ', data);
      this.handleMessage(data);
      // Handle the data
    });

    this.hubConnection?.on('ForceDisconnect', () => {
      console.warn('Disconnected due to duplicate connection');
      this.hubConnection?.stop();
    });

    this.hubConnection?.on('ReceiveMirrorEvent', (message: MirrorEvent) => {
      // console.log('Received data: ', message);
      this.mirorMessagesSubject.next([message as MirrorEvent]);
    });

    // this.isStartedListener = true;
  }

  public async handleMessage(message: SignalRMessage) {
    console.log("message.type", message.type)
    switch (message.type) {
      case 'Duty':
      case 'AddGuardToWorkgroup':
      case 'RemoveGuardOutOfWorkgroup':
      case 'RemindStartDuty':
        this.notificationMessageSubject.next([message as SignalRMessage]);
        break;

      case 'Knight_CheckIn':
        const chatMessages = this.seekerMessagesSubject.value;
        this.seekerMessagesSubject.next([
          ...chatMessages,
          message as SignalRMessage,
        ]);
        break;
      case 'BroastCast':
        const notifications = this.knightMessageSubject.value;
        this.knightMessageSubject.next([
          ...notifications,
          message as SignalRMessage,
        ]);
        break;
      case 'Emergency':
      case 'Emegency':
        this.emergencyMessageSubject.next([message as SignalRMessage]);
        this.notificationMessageSubject.next([message as SignalRMessage]);
        await this.showEmergencyDialog(message);

        break;
      case MESSAGE_TYPE.NOTIFICATION:
      case MESSAGE_TYPE.CHAT_NOTIFICATION:
        // const lvNotifications = this.notificationMessageSubject.value;
        this.notificationMessageSubject.next([message as SignalRMessage]);
        break;
      case 'GPS_REALTIME':
        // const lvNotifications = this.notificationMessageSubject.value;
        this.gpsRealtimeMessageSubject.next([message as SignalRMessage]);
        break;
      case 'GPS_OUTSIDE_REALTIME':
      case 'GPS_OUTSIDE_NOTIFY':
      case 'START_DUTY_NOTIFY':
      case 'STOP_DUTY_NOTIFY':
      case 'EMERGENCY_NOTIFY':
      case 'CHAT_MESSAGE_NOTIFY':
      case 'CHAT_GROUP_MESSAGE_NOTIFY':
      case 'PTT_GROUP_MESSAGE_NOTIFY':
        this.gpsRealtimeOutsideMessageSubject.next([message as SignalRMessage]);
        break;
      case MESSAGE_TYPE.REMOVE_GUARD_OUT_OF_ROSTER:
      case MESSAGE_TYPE.ADD_GUARD_TO_ROSTER:
        this.notificationMessageSubject.next([message as SignalRMessage]);
        break;
      case 'BULK_CREATE_PROGRESS':
        console.log("message.text", message.text);
        this.bulkCreateProgressSubject.next(JSON.parse(message.text!));
        break;
      default:
        console.warn('Unknown message type:', message);
    }
  }

  async showEmergencyDialog(message: SignalRMessage) {
    const modal = await this.modalController.create({
      component: EmegencyDialogComponent,
      cssClass: 'fullscreen-modal',
      componentProps: {
        data: {
          latitude: message.latitude,
          longitude: message.longitude,
          userId: message.senderId,
        },
      },
    });
    modal.onDidDismiss().then((res) => {
      // if (res && res.data && res.data) {
      //   // To do
      // }
      this.mirrorUsers.forEach((userId) => {
        this.sendMirrorEvent(userId, {
          type: "emergency-close",
          payload: { userId }
        });
      });
    });
    await modal.present();
  }

  public loadMessagesFromApi(messages: SignalRMessage[], type: string): void {
    switch (type) {
      case 'Seeker':
        const currentMessages = this.seekerMessagesSubject.value;
        this.seekerMessagesSubject.next([...currentMessages, ...messages]);
        break;
      case 'Knight':
        const notifications = this.knightMessageSubject.value;
        this.knightMessageSubject.next([...notifications, ...messages]);
        break;
    }
  }

  public clearMessages(type: string) {
    switch (type) {
      case 'Seeker':
        this.seekerMessagesSubject.next([]);
        break;
      case 'Knight':
        this.knightMessageSubject.next([]);
        break;
    }
  }

  public clearMessage(message: SignalRMessage) {
    const element = this.knightMessageSubject.value.find(
      (p) => p.senderId === message.senderId
    );
    if (element) {
      this.knightMessageSubject.next(
        this.knightMessageSubject.value.filter(
          (p) => p.senderId !== message.senderId
        )
      );
    }
  }

  sendMirrorEvent(userId: string, event: any) {
    this.hubConnection?.invoke("SendMirrorEvent", userId, event);
  }

  // onMirrorEvent() {
  //   this.hubConnection?.on("ReceiveMirrorEvent", (message: MirrorEvent) => {
  //     console.log('Received data: ', message);
  //     this.mirorMessagesSubject.next([message as MirrorEvent]);
  //   });
  // }
}
